import { Tranche } from "@lib/tranche";
import { Evaluator } from "@lib/types";
import { Funder, Recommender } from "./aggregate";

export function getDefaultTrancheProfile(holdProposalId: string): Tranche[] {
  return [
    {
      height: 0,
      allocations: {
        [holdProposalId]: { amount: 1e12, bottomPlaced: true },
      },
    },
    {
      height: 0.1,
      allocations: {},
    },
  ];
}

// TODO: the default tranche profile should be contained in the event, otherwise
// a users initial tranche profile will change if we update the definition of
// the default tranche profile, which would be bad
export function initEvaluator(
  evaluatorId: string,
  userId: string,
  shortname: string,
  evaluatorType: Evaluator["type"],
  holdProposalId: string,
  meanRecommenderThreshold?: number,
): Evaluator {
  const evaluations = {
    [holdProposalId]: {
      evaluableType: "proposal",
      state: "evaluated",
      evaluableId: holdProposalId,
      setToZero: false,
    },
  } as const;

  if (evaluatorType === "recommender") {
    return {
      type: "recommender",
      status: "active",
      id: evaluatorId,
      memberId: userId,
      shortname,
      evaluations,
      trancheList: getDefaultTrancheProfile(holdProposalId),
      meanRecommenderThreshold,
      // deferrals: {},
      outsideDollarSubstitutionRate: 0,
    };
  } else {
    return {
      type: "funder",
      status: "active",
      id: evaluatorId,
      memberId: userId,
      shortname,
      evaluations,
      scores: {},
      incrementalEvalIndex: 0,
      incrementalEvalSteps: [],
      budget: 0,
      speculationGrantSettlementBudget: null,
      trancheList: getDefaultTrancheProfile(holdProposalId),
    };
  }
}

export function initFunder(
  evaluatorId: string,
  userId: string,
  shortname: string,
  holdProposalId: string,
): Funder {
  const evaluations = {
    [holdProposalId]: {
      evaluableType: "proposal",
      state: "evaluated",
      evaluableId: holdProposalId,
      setToZero: false,
    },
  } as const;

  return {
    type: "funder",
    status: "active",
    id: evaluatorId,
    memberId: userId,
    shortname,
    evaluations,
    scores: {},
    incrementalEvalIndex: 0,
    incrementalEvalSteps: [],
    budget: 0,
    speculationGrantSettlementBudget: null,
    trancheList: getDefaultTrancheProfile(holdProposalId),
  };
}

export function initRecommender(
  evaluatorId: string,
  userId: string,
  shortname: string,
  holdProposalId: string,
  meanRecommenderThreshold?: number,
): Recommender {
  const evaluations = {
    [holdProposalId]: {
      evaluableType: "proposal",
      state: "evaluated",
      evaluableId: holdProposalId,
      setToZero: false,
    },
  } as const;

  return {
    type: "recommender",
    status: "active",
    id: evaluatorId,
    memberId: userId,
    shortname,
    evaluations,
    trancheList: getDefaultTrancheProfile(holdProposalId),
    meanRecommenderThreshold,
    outsideDollarSubstitutionRate: 0,
  };
}
